// extracted by mini-css-extract-plugin
export default {"icon":"FileType_icon__5L3BL"};